import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { useUserEventLogger } from '@repo/tracking-service';
import { Drawer, DrawerContent, DrawerHeader, DrawerBody, List, IconButton, Icon } from '@repo/ui';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { COMMON_PATHS } from '@/lib/constants/paths';

export const RefundGuideButtonModal = NiceModal.create(() => {
  const modal = useModal();
  const router = useRouter();
  const { sendViewEvent, sendClickEvent } = useUserEventLogger();

  useEffect(() => {
    if (modal.visible) {
      sendViewEvent('home_modal_refund-guide', undefined, { isAllowRetry: true });
    }
  }, [modal.visible, sendViewEvent]);

  const handleClose = () => {
    modal.remove();
  };

  return (
    <Drawer open={modal.visible} onOpenChange={(open) => (open ? modal.show() : modal.remove())} onClose={handleClose} dismissible={false}>
      <DrawerContent>
        <DrawerHeader className={'flex justify-between items-center body-medium-bold'}>
          비즈넵 환급의 무엇이 궁금하신가요?
          <IconButton iconType={'close'} onClick={handleClose} />
        </DrawerHeader>
        <DrawerBody>
          <List
            className={'cursor-pointer hover:bg-gray-50'}
            leadingElement={<img src="/images/illus-icons/fill-c-question-bl-rg.svg" alt="question icon" />}
            title={'자주 묻는 질문'}
            description={'진행 단계별 자주 묻는 질문을 정리했어요.'}
            supportingElement={<Icon type="chevron-right" size={20} />}
            primaryAction
            onClick={() => {
              sendClickEvent('home_modal_faq');
              router.push(COMMON_PATHS.환급자주묻는질문);
              modal.remove();
            }}
          />
          <List
            className={'cursor-pointer hover:bg-gray-50'}
            leadingElement={<img src="/images/illus-icons/fill-moneybag-gn-rg.svg" alt="moneybag icon" />}
            title={'환급금은 이렇게 입금돼요'}
            description={'신청 후 어떻게 입금되는지 정리했어요.'}
            supportingElement={<Icon type="chevron-right" size={20} />}
            primaryAction
            onClick={() => {
              sendClickEvent('home_modal_how-to-deposit');
              router.push(COMMON_PATHS.환급금입금방법);
              modal.remove();
            }}
          />
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
});
